import axios from "axios";

interface ApiResponse {
  data: any[];
  status: string;
}

const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

const getData = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_honorary_membership_registration/`
    );
    return data;
  } catch (error) {
    // return {
    //   message: error.message,
    //   status: error.response.status,
    // };
    return error;
  }
};

const getDataForExcel = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_honorary_membership_registration_list_excel/`
    );
    return data;
  } catch (error) {
    // return {
    //   message: error.message,
    //   status: error.response.status,
    // };
    return error;
  }
};

const saveRow = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_edit_individual_members_application/`,
      payload
    );
    return data;
  } catch (error) {}
};

const approveMembership = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_approve_individual_membership/`,
      payload
    );
    return data;
  } catch (error) {}
};

const removeMembership = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_remove_individual_membership/`,
      payload
    );
    return data;
  } catch (error) {}
};

const deleteRow = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/submit_delete_individual_membership_registration/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const getIndividualMemberType = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_individual_member_type/`
    );
    return data;
  } catch (error) {}
};

const getMemberType = async () => {
  try {
    const { data } = await axios.get<ApiResponse>(
      `${API_BASE_URL}/get_member_type/`
    );
    return data;
  } catch (error) {}
};

const renewMembership = async (payload: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/renew_individual_membership/`,
      payload
    );
    return data;
  } catch (error) {}
};

const getInfo = async (rowId: any) => {
  try {
    const { data } = await axios.post<ApiResponse>(
      `${API_BASE_URL}/get_individual_info/`,
      rowId
    );
    return data;
  } catch (error) {
    return error;
  }
};

const AssociateMembershipController = {
  getData,
  getDataForExcel,
  saveRow,
  approveMembership,
  removeMembership,
  deleteRow,
  getIndividualMemberType,
  getMemberType,
  renewMembership,
  getInfo,
};
export default AssociateMembershipController;
